import React, { useState } from "react";
import Button from "../../../ui/Button/Button";
import styles from "./styles.module.scss";
import { IconButton } from "../../../ui/IconButton/IconButton";
import { PenIconSolid } from "../../../assets/icons/PenIconSolid";
import { TrashIconSolid } from "../../../assets/icons/TrashIconSolid";
import { AddIcon } from "../../../assets/icons/AddIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveDialog } from "../../../store/slices/dialogSlice";
import {
  setActiveAssistant,
  setNewAssistant,
  setUpdateAssistant,
} from "../../../store/slices/assistantSlice";
import {
  getInstructionsList,
  putAssistant,
} from "../../../utils/api/actions/assistant";
import { handleSetEditMode } from "../../../utils/methods/setEditMode";
import { toast } from "react-toastify";
import { validateFields } from "../../../utils/methods/validationField";
import { ClipLoader } from "react-spinners";

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // user
  const id =
    useSelector((state) => state.user?.data?.id) ||
    localStorage.getItem("@storage_User_Id");

  // assistants
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );
  const assistantsData = useSelector((state) => state.assistant.dataAssistants);
  const activeAssistant = useSelector(
    (state) => state.assistant.activeAssistant
  );

  // states
  const [loadingSaveChanges, setLoadingSaveChanges] = useState(false); // [setLoadingSaveChanges]

  // consts
  const isEditFromHeader = location.state?.fromEditButton === true;
  const errorFields = (message) =>
    toast.error(message, {
      toastId: "errorFields",
    });

  // functions
  const handlerTestAssistant = () => {
    dispatch(setActiveDialog(null));
    navigate(`${activeAssistant?.id}/test`);
  };

  const handlerAddAssistantData = () => {
    dispatch(getInstructionsList());
    dispatch(setActiveAssistant(null));
    dispatch(setNewAssistant(getAssistantData(id)));
    navigate("new");
  };

  //delete past here

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  const handlerSendAssistantData = async () => {
    if (updateAssistant) {
      setLoadingSaveChanges(true);
      if (isEmptyObject(updateAssistant)) {
        if (validateFields(updateAssistant, errorFields)) {
          await dispatch(putAssistant(updateAssistant));
          await dispatch(setUpdateAssistant(null));
          setLoadingSaveChanges(false);
          // console.log("upd assistant", updateAssistant);
        }
      }
    }
  };

  const handleEdit = () => {
    navigate(`update?id=${activeAssistant?.id}`);
    handleSetEditMode(dispatch, activeAssistant);
  };

  const handleCancelEdit = () => {
    if (isEditFromHeader) {
      navigate(`${activeAssistant?.id}/test`);
    }
    dispatch(setUpdateAssistant(null));
  };

  return (
    <div className={styles.header}>
      <h2>Ассистенты</h2>
      {updateAssistant ? (
        <div className={styles.iconsContainer}>
          <Button
            title={"Сохранить"}
            leftIcon={
              loadingSaveChanges && <ClipLoader size={12} color={"#fff"} />
            }
            onClick={handlerSendAssistantData}
          />
          <Button
            className={styles.cancel}
            title={"Отменить"}
            onClick={handleCancelEdit}
          />
        </div>
      ) : (
        <div className={styles.actionsButtons}>
          <Button title={"Тестировать"} onClick={handlerTestAssistant} />
          <div className={styles.iconsContainer}>
            <IconButton icon={<AddIcon />} onClick={handlerAddAssistantData} />
            {assistantsData?.length > 0 && (
              <IconButton
                onClick={handleEdit}
                btnStyles={styles.editButton}
                icon={<PenIconSolid size={12} fill={"white"} />}
              />
            )}
            {assistantsData?.length > 0 && (
              <IconButton
                btnStyles={styles.deleteButton}
                icon={<TrashIconSolid size={12} fill={"white"} />}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const getAssistantData = (id) => {
  let assistant = {
    name: "", // название ассистента
    firstName: "", // имя ассистента
    companyDescription: "", // описание компании
    driveFile: null,
    faq: [], // вопрос-ответ
    collectedData: [], // собираемые данные с пользователя
    purpose: "", // цель
    answerLength: "Короткий", // длина ответа
    appeal: "Вы", // обращение
    communicationStyle: "", // стиль общения
    actions: [{ action: "", result: "" }], // действия
    responseDelay: "15",
    selectedTemplate: null,
    splitMessage: false,
    settings: {
      instruction: "",
      modelId: "29137bc4-704c-43b8-8555-e55124f99b72",
      answerFormat: "JSON",
      temperature: 0.5,
      maxLength: 1024,
      topP: 1,
      useFiles: true,
      useReminder: true,
      grpcServicePort: "2901",
      apiServicePort: "50055",
      useTimePeriod: false,
      timeZone: "+3",
      startWorkTime: "00:00:00",
      endWorkTime: "00:00:00",
    },
    files: [],
    userId: id,
  };
  return assistant;
};
